import { render, staticRenderFns } from "./noticePractise.vue?vue&type=template&id=4126c232&scoped=true&"
import script from "./noticePractise.vue?vue&type=script&lang=js&"
export * from "./noticePractise.vue?vue&type=script&lang=js&"
import style0 from "./noticePractise.vue?vue&type=style&index=0&id=4126c232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4126c232",
  null
  
)

export default component.exports